export const SEND_HOME_MODAL = {
  title: 'robotCleaningControl.sendHome.title',
  modalMessage: 'robotCleaningControl.sendHome.message',
};

export const CANCEL_CLEANING_MODAL = {
  title: 'robotCleaningControl.cancelCleaning.title',
  modalMessage: 'robotCleaningControl.cancelCleaning.message',
};

export const SKIP_ROUTE_MODAL = {
  title: 'robotCleaningControl.skipRoute.title',
  modalMessage: 'robotCleaningControl.skipRoute.message',
  alertMessage: 'robotCleaningControl.skipRoute.alert',
};
